import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Content,
  Header,
  Page,
} from '@vivicta/ui';

import { GitHubConnectionBanner } from './GitHubConnectionBanner';

export type PageHighlight = {
  title: string;
  description: string;
};

/**
 * Stand-in for a page whose data is only readable as the user: says what the
 * page will show once GitHub is connected, instead of only asking to connect.
 */
export const GitHubPagePreview = ({
  title,
  subtitle,
  reason,
  highlights,
}: {
  title: string;
  subtitle?: string;
  /** Completes "Connect your company GitHub account to see …". */
  reason: string;
  highlights: ReadonlyArray<PageHighlight>;
}) => (
  <Page>
    <Header title={title} subtitle={subtitle} />
    <Content className="flex flex-col gap-4">
      <GitHubConnectionBanner
        message={`Connect your company GitHub account to see ${reason}. The portal reads GitHub as you, so it shows only what you can open.`}
      />
      <Card>
        <CardHeader>
          <CardTitle>What {title} shows</CardTitle>
          <CardDescription>
            Available as soon as GitHub is connected.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {highlights.map(highlight => (
              <li
                key={highlight.title}
                className="rounded-lg border border-border bg-muted/40 p-4"
              >
                <p className="text-sm font-medium text-foreground">
                  {highlight.title}
                </p>
                <p className="mt-1 text-sm text-muted-foreground">
                  {highlight.description}
                </p>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </Content>
  </Page>
);
